import React, { useState } from 'react';
import { db, auth } from '../firebase';
import { doc, updateDoc } from 'firebase/firestore';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-hot-toast';

const GOLD = '#B8860B';

export default function StylistOnboarding() {
  const [step, setStep] = useState(1);
  const [specialties, setSpecialties] = useState([]);
  const [bio, setBio] = useState('');
  const navigate = useNavigate();

  const options = ['Fade Specialist', 'Beard Sculpting', 'Hair Coloring', 'Bridal Styling', 'Wig Installation', 'Chemical Texturizing'];

  const toggleSpecialty = (item) => {
    setSpecialties(prev => prev.includes(item) ? prev.filter(i => i !== item) : [...prev, item]);
  };

  const handleFinish = async () => {
    try {
      const stylistRef = doc(db, 'barbers', auth.currentUser.uid);
      await updateDoc(stylistRef, {
        specialties,
        bio,
        onboardingComplete: true,
        setupAt: new Date()
      });
      toast.success("Profile Activated!");
      navigate('/stylist/dashboard');
    } catch (err) {
      toast.error("Setup failed");
    }
  };

  return (
    <div style={containerStyle}>
      <div style={cardStyle}>
        <div style={progressContainer}>
          <div style={{...progressBar, width: step === 1 ? '50%' : '100%'}}></div>
        </div>

        {step === 1 ? (
          <>
            <h2 style={{color: GOLD}}>WHAT ARE YOUR SPECIALTIES?</h2>
            <p style={{color: '#888', marginBottom: '20px'}}>Select all that apply to your craft.</p>
            <div style={gridStyle}>
              {options.map(opt => (
                <button 
                  key={opt}
                  onClick={() => toggleSpecialty(opt)}
                  style={specialties.includes(opt) ? activeChip : inactiveChip}
                >
                  {opt}
                </button>
              ))}
            </div>
            <button onClick={() => setStep(2)} style={nextBtn}>NEXT</button>
          </>
        ) : (
          <>
            <h2 style={{color: GOLD}}>TELL LAGOS ABOUT YOU</h2>
            <textarea 
              placeholder="Briefly describe your style and experience..."
              value={bio}
              onChange={(e) => setBio(e.target.value)}
              style={textAreaStyle}
            />
            <button onClick={handleFinish} style={nextBtn}>COMPLETE SETUP</button>
          </>
        )}
      </div>
    </div>
  );
}

// STYLES
const containerStyle = { minHeight: '100vh', background: '#001F3F', display: 'grid', placeItems: 'center', padding: '20px' };
const cardStyle = { background: '#050a0f', padding: '40px', borderRadius: '30px', width: '100%', maxWidth: '500px', border: `1px solid ${GOLD}`, textAlign: 'center' };
const progressContainer = { width: '100%', height: '4px', background: '#222', borderRadius: '10px', marginBottom: '30px' };
const progressBar = { height: '100%', background: GOLD, borderRadius: '10px', transition: '0.3s ease' };
const gridStyle = { display: 'flex', flexWrap: 'wrap', gap: '10px', justifyContent: 'center', marginBottom: '30px' };
const activeChip = { padding: '10px 20px', background: GOLD, color: '#000', border: 'none', borderRadius: '50px', fontWeight: 'bold', cursor: 'pointer' };
const inactiveChip = { padding: '10px 20px', background: 'transparent', color: GOLD, border: `1px solid ${GOLD}`, borderRadius: '50px', cursor: 'pointer' };
const textAreaStyle = { width: '100%', height: '150px', padding: '15px', background: '#000', color: '#fff', border: '1px solid #333', borderRadius: '15px', marginBottom: '20px', boxSizing: 'border-box' };
const nextBtn = { width: '100%', padding: '15px', background: GOLD, border: 'none', borderRadius: '50px', fontWeight: 'bold', cursor: 'pointer' };
